<template>
<div class="chapter">
<div class="inner_page">
<h1>Sis Boom Bah</h1>
<h3 class="sigil_not_in_toc">Jane Heller</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?14723814